import a7a5_tron from "@src/app/assets/currency/a7a5_tron.svg"
import amd from "@src/app/assets/currency/amd.svg"
import aud from "@src/app/assets/currency/aud.svg"
import azn from "@src/app/assets/currency/azn.svg"
import bgn from "@src/app/assets/currency/bgn.svg"
import bnb from "@src/app/assets/currency/bnb.svg"
import bob from "@src/app/assets/currency/bob.svg"
import brl from "@src/app/assets/currency/brl.svg"
import btc from "@src/app/assets/currency/btc.svg"
import col from "@src/app/assets/currency/col.svg"
import dai_bnb from "@src/app/assets/currency/dai_bnb.svg"
import dai_eth from "@src/app/assets/currency/dai_eth.svg"
import defaultIcon from "@src/app/assets/currency/default.svg"
import eth from "@src/app/assets/currency/eth.svg"
import eth_arb from "@src/app/assets/currency/eth_arb.svg"
import eur from "@src/app/assets/currency/eur.svg"
import ltc from "@src/app/assets/currency/ltc.svg"
import mxn from "@src/app/assets/currency/mxn.svg"
import pol from "@src/app/assets/currency/pol.svg"
import ton from "@src/app/assets/currency/ton.svg"
import trx from "@src/app/assets/currency/trx.svg"
import usd from "@src/app/assets/currency/usd_fiat.svg"
import usdc_arb from "@src/app/assets/currency/usdc_arbitrum.svg"
import usdc_eth from "@src/app/assets/currency/usdc_eth.svg"
import usdc_pol from "@src/app/assets/currency/usdc_polygon.svg"
import usdt_arb from "@src/app/assets/currency/usdt_arbitrum.svg"
import usdt_bsc from "@src/app/assets/currency/usdt_bsc.svg"
import usdt_eth from "@src/app/assets/currency/usdt_eth.svg"
import usdt_polygon from "@src/app/assets/currency/usdt_polygon.svg"
import usdt_ton from "@src/app/assets/currency/usdt_ton.svg"
import usdt_trx from "@src/app/assets/currency/usdt_trx.svg"

type Props = { network: string; symbol: string }
const res: any = []

// @ts-ignore
const iconsContext = require.context(
  "@src/app/assets/currency",
  false,
  /\.svg$/,
)

const icons: Record<string, string> = iconsContext
  .keys()
  .reduce((acc: Record<string, string>, key: string) => {
    const name = key.replace("./", "").replace(".svg", "")

    acc[name] = iconsContext(key)

    return acc
  }, {})

export const getCurrencyIcon = ({ network, symbol }: Props) => {
  const symbolKey = symbol.toLowerCase()
  const networkKey = `${symbol.toLowerCase()}_${network.toLowerCase()}`

  const i = icons[networkKey] || icons[symbolKey]

  if (i) {
    return i
  }

  switch (true) {
    case network === "bitcoin" && symbol === "BTC":
      return btc
    case network === "ethereum" && symbol === "ETH":
      return eth
    case network === "ethereum" && symbol === "USDT":
      return usdt_eth
    case network === "ethereum" && symbol === "DAI":
      return dai_eth
    case network === "tron" && symbol === "TRX":
      return trx
    case network === "tron" && symbol === "USDT":
      return usdt_trx
    case network === "litecoin" && symbol === "LTC":
      return ltc
    case network === "bsc" && symbol === "BNB":
      return bnb
    case network === "bsc" && symbol === "BSCUSD":
      return usdt_bsc
    case network === "bsc" && symbol === "DAI":
      return dai_bnb
    case network === "polygon" && symbol === "USDT":
      return usdt_polygon
    case network === "polygon" && symbol === "POL":
      return pol
    case network === "ethereum" && symbol === "USDC":
      return usdc_eth
    case network === "polygon" && symbol === "USDC":
      return usdc_pol
    case network === "ton" && symbol === "TON":
      return ton
    case network === "ton" && symbol === "USDT":
      return usdt_ton
    case network === "arbitrum" && symbol === "ETH":
      return eth_arb
    case network === "arbitrum" && symbol === "USDT0":
      return usdt_arb
    case network === "arbitrum" && symbol === "USDC":
      return usdc_arb
    case network === "tron" && symbol === "A7A5":
      return a7a5_tron
    case network === "fiat" && symbol === "USD":
      return usd
    case network === "fiat" && symbol === "EUR":
      return eur
    case network === "fiat" && symbol === "BRL":
      return brl
    case network === "fiat" && symbol === "MXN":
      return mxn
    case network === "fiat" && symbol === "COP":
      return col
    case network === "fiat" && symbol === "AMD":
      return amd
    case network === "fiat" && symbol === "AZN":
      return azn
    case network === "fiat" && symbol === "AUD":
      return aud
    case network === "fiat" && symbol === "BOB":
      return bob
    case network === "fiat" && symbol === "BGN":
      return bgn
    default:
      // res.push(symbol)
      return defaultIcon
  }
}
